import { render, staticRenderFns } from "./TenableReader.vue?vue&type=template&id=288d39b3"
import script from "./TenableReader.vue?vue&type=script&lang=ts"
export * from "./TenableReader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_bef45e0e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('288d39b3')) {
      api.createRecord('288d39b3', component.options)
    } else {
      api.reload('288d39b3', component.options)
    }
    module.hot.accept("./TenableReader.vue?vue&type=template&id=288d39b3", function () {
      api.rerender('288d39b3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/upload_tabs/tenable/TenableReader.vue"
export default component.exports